export default {
  get: (name, defaultValue) => {
    const value = sessionStorage.getItem(name);
    if (value === null) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return defaultValue;
    }
  },
  set: (key, value) => {
    let dataToStore = '';
    if (typeof value === 'object') {
      dataToStore = JSON.stringify(value);
    } else {
      dataToStore = value;
    }
    try {
      sessionStorage.setItem(key, dataToStore);
    } catch (error) {
      if (
        error instanceof DOMException &&
        (error.name === 'QuotaExceededError' ||
          error.name === 'NS_ERROR_DOM_QUOTA_REACHED')
      ) {
        // Si se llena el almacenamiento, la clave se omite sin romper la app.
        // eslint-disable-next-line no-console
        console.warn(
          `sessionManager: storage quota exceeded, ignoring key ${key}`
        );
      } else {
        throw error;
      }
    }
  },
  clear: (key) => sessionStorage.removeItem(key),
  clearAll: () => sessionStorage.clear(),
};